<main class="main-container bg-delfi container-fixed">
   <mat-toolbar  class="topbar topbar-sticky justify-content-center align-items-center gap-8 toolbar-transparent" color="transparent" >
       <img [ngSrc]="logoPath" width="36" height="36" alt="homepage" class="dark-logo logo--brand" priority>
       <span class="site-brand-name">{{ sitename }}</span>
   </mat-toolbar> 
<router-outlet></router-outlet>
</main>
 <ngx-assistance-form 
    [buttonIcon]="true"
    [buttonMessage]="false"
    [buttonPosition]="'bottom'"
    [formEnter]="'bottom'"
    [adapter]="assistanceFormAdapterImplementationService" 
    [recaptchaSiteKey]="recaptchaSiteKey"
    [person]="person"
    [statictoken]="staticToken"
    #assistanceForm
    ></ngx-assistance-form>